module.exports = __webpack_public_path__ + "img/modern-black-frame-left-shadowed.267089d1.png";